<template>
  <div class="manage-login-box">
    <form method="post" @submit.prevent="login()" autocomplete="on">
      <div class="login">
        <h1 class="title">オリジナルブレンド茶<br />顧客管理システム</h1>
        <label class="label">ユーザーID</label><span class="span help is-danger" v-html="e_msg_u_id"></span>
        <p class="control"><input type="text" name="manage_user" autocomplete="on" placeholder="ユーザーID" class="input" v-model="user_id"></p>
        <label class="label">パスワード</label><span class="span help is-danger" v-html="e_msg_u_pass"></span>
        <input type="password" name="manage_pass" autocomplete="on" placeholder="パスワード" class="input" v-model="user_pass">
      </div>
      <input type="submit" class="button is-catatoru" value="ログイン">
    </form>
  </div>
</template>

<script>
export default {
  name: 'manageLogin',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_id: '',
      e_msg_u_pass: '',
      user_id: '',
      user_pass: '',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.$route.query.type === 'reload') {
      this.$alert('alert', 'ブラウザがリロードされたため、ログアウトしました。\n再度ログインしてください。');
    } else if (this.$route.query.type === 'logout') {
      this.$alert('alert', 'ログアウトしました。');
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    login () {
      let eFlg = false;
      if (!this.user_id) {
        this.e_msg_u_id = 'ユーザIDを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_id = '';
      }
      if (!this.user_pass) {
        this.e_msg_u_pass = 'パスワードを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_pass = '';
      }
      // this.$router.push({path: '/manage/main'});
      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._m_data_set({user_id: this.user_id, user_pass: this.user_pass});
        ld._post_cb_f = this.login_cb;
        ld._load_start('manage/login.php');
      }
      return false;
    },
    login_cb (data) {
      if (data.res === 1) {
        this.$store.commit('mLoginInfo/set_data', data.data);
        // this.$store.commit('mMain/set_data', new Date());

        this.$router.push({path: '/manage/main'});
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-login-box {
  text-align: center;

  input {
    ime-mode: inactive;
  }

  .login {
    width: 400px;
    margin: 10px auto;
    .title {
      color: #1b2010;
      margin: 78px 0 74px 0;
    }
    input[type="text"],
    input[type="password"] {
      margin-bottom: 15px;
      font-size: 1rem;
      height: 50px;
    }
  }

  .label {
    border-left: 6px solid #738f53;
    text-align: left;
    float: left;
    padding: 0 0 0 10px;
    font-weight: bold;
    color: #5c5945;
    height: 23px;
    line-height: 23px;
    font-size: 1.1rem;
    margin-bottom: 6px;
  }

  .span {
    float: right;
    color: #F00;
    font-size: .8rem;
  }

  .button {
    outline: 0;
    margin-top: 8px;
    border: none;
    color: #FFF;
    width: 400px;
    height: 70px;
    font-weight: bold;
    font-size: 1.4rem;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
